/* 🤖 this file was generated by svg-to-ts */
export const matIconMoreHoriz: {
  name: 'more-horiz';
  data: string;
} = {
  name: 'more-horiz',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"/></svg>`
};
